import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1452aa88&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Server\\domains\\localhost\\ss\\wa-apps\\shop\\plugins\\giftcertificates\\build\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1452aa88')) {
      api.createRecord('1452aa88', component.options)
    } else {
      api.reload('1452aa88', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1452aa88&", function () {
      api.rerender('1452aa88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/pages/marketing_item/index.vue"
export default component.exports